//BUSINESSES AND GOVERNMENT RESOURCES PAGE
//*******************************************************************
//*******************************************************************
//IMPORTS:
//EXTERNAL & PACKAGE 
import $ from 'jquery'
import Popper from 'popper.js'
import React from 'react'
import {graphql, Link} from 'gatsby'
//COMPONENT DEPENDENCIES
import Heading from '../../components/heading'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import PageHeader from '../../components/PageHeader'
import TableOfContents from '../../components/TableOfContents'
import FullWidthImage from '../../components/FullWidthImage'
import ContentBlock from  '../../components/ContentBlock'
import TextBlock from '../../components/textblock'
import Header from '../../components/Header'
import ContentList from '../../components/ContentList'
import ContentGridNew from '../../components/ContentGridNew'
import BodySection from '../../components/BodySection'
import ContentsTable from '../../components/ContentsTable'
import AccordionTable from '../../components/AccordionTable'
import '../../styles/accordionTable.css'

import Helmet from "react-helmet"
//*******************************************************************
//*******************************************************************  
const resourcesPage = ({data}) => {
    
    const resources = data.business_government_resources.edges
    
    return (   
        
        <div>

            <Helmet>

                <title>NJCCIC Business and Government Resouces </title>
                <meta name="description" content="The NJCCIC provides a collection of resources to businesses and governments to aid agencies in their efforts to stay secure"/>

            </Helmet>

            <Heading/>
            
            <Navbar/>
        
            {resources.map(({node: {page_title, image, image_2, introductory_text, subheader, content_group, content_accordion_item_cyber_disaster_recovery, content_accordion_item_it_security_publications, content_accordion_item_resources, text, headers} }) => (
    
                <div class="container-fluid">
        
                    <PageHeader divClass="containerWidth" elementClass="pageHeader centerText" title={page_title}/>
                    
                    <div class="container containerWidth">
                        
                        <div class="row">
        
                            <TextBlock elementClass="standardText introPadding" text={introductory_text}/>
                            
                        </div>
                        
                    </div>     
        
                    <ContentsTable testClass="testClass container containerWidth grid2Container" elementClass="col-12 col-md-3 grid2 blocks block2 block2Alt" dangerousClass="standardText blockText margin btnWidth" headerStyles="header contentTitle" data={content_group} iconId="iconsGroup"/>
                    
                    <FullWidthImage id="businessBanner" src={image}/>

                    <div class="container containerWidth">

                        <Header divClass="container containerWidth" styles="header contentTitle" title={headers[0].section_name} id="nj-state-resources"/>                    

                        <AccordionTable layoutClass="accordionTable alt col-10 offset-1 col-lg-12 offset-lg-0" data={content_accordion_item_resources}/>       

                    </div>   

                    <div class="container containerWidth">

                        <Header divClass="container containerWidth" styles="header contentTitle" title={headers[1].section_name} id="cyber-disaster-recovery"/>                    

                        <AccordionTable layoutClass="accordionTable alt col-10 offset-1 col-lg-12 offset-lg-0" data={content_accordion_item_cyber_disaster_recovery}/>       

                    </div>   

                    <div class="container containerWidth">

                        <Header divClass="container containerWidth" styles="header contentTitle" title={headers[2].section_name} id="publications"/>                    

                        <AccordionTable layoutClass="accordionTable alt col-10 offset-1 col-lg-12 offset-lg-0" data={content_accordion_item_it_security_publications}/>     

                    </div>  
                    
                    <div class="container containerWidth">
                        
                        <TextBlock elementClass="col-12 textPadding" id='callToActionBlock' dangerousClass="callToAction bodyText presentation" text={text}/>
                        
                    </div>
                       
                </div>
            
            ))}
        
            <Footer/>                
            
        </div> 

    )   
    
}
//*******************************************************************
//******************************************************************* 
export const query = graphql`
    query {
        business_government_resources: allButterPage(filter: {slug: { eq: "business-government-resources" } }) {
            edges {
                node {
                    slug
                    seo_title
                    page_title 
                    image
                    image_alt_text
                    image_2
                    introductory_text


                    content_accordion_item_resources {
                        content_heading
                        section_id
                        icon
                        main_text
                    }

                    content_accordion_item_cyber_disaster_recovery {
                        content_heading
                        section_id
                        icon
                        main_text
                    }

                    content_accordion_item_it_security_publications {
                        content_heading
                        section_id
                        icon
                        main_text
                    }


                    subheader
                    content_group {
                        section_name
                        text
                        icon
                    }
                    section_label_a
                    content_list_a {
                        section_name
                        text
                        anchor_id
                    }
                    section_label_b
                    text
                    headers {
                        section_name
                    }
                    content_group_resources {
                        icon
                        section_name
                        preview_text
                        toggle_target
                        main_text
                    }
                    content_group_disaster_recovery {
                        icon
                        section_name
                        preview_text
                        toggle_target
                        main_text
                    }
                    content_group_publications {
                        icon
                        section_name
                        preview_text    
                        toggle_target
                        main_text
                    }
                }
            }
        }
       
    }
`
export default resourcesPage
//******************************************************************* 